'use strict';

import UrlHelpers from './UrlHelpers';

export default {
    resolving: false,
    category: null,
    categorySlug: null,
    current: 1,
    query: null,
    total: 0,
    totalPages: 0,
    sort: '',
    limit:30,
    aggregations: [],
    filters: {},
    trigger: 1,
    grid: true,

    setStacked() {
        this.grid = false;
    },

    setGrid() {
        this.grid = true;
    },

    /**
     * Search the API
     * @param {string} query
     */
    search(query) {

        this.resolving = true;

        if (query) {
            this.query = query;
        }

        return new Promise((resolve, reject) => {

            let params = {
                page: this.current,
                sort: this.sort
            };

            _.each(this.filters, (filter) => {

                let queryString = filter.getQueryString();
                if (typeof queryString == 'string') {
                    UrlHelpers.setParam(filter.field, queryString);
                    params[filter.field] = queryString;
                } else {
                    _.each(queryString, (value, field) => {
                        UrlHelpers.setParam(field, value);
                        params[field] = value;
                    });
                }
            });

            let endpoint = '/api/search';

            if (this.category) {
                endpoint = '/categories/' + this.categorySlug;
            } else {
                params.term = this.query;
            }

            axios({
                method: 'get',
                url: endpoint,
                headers: {
                    'Accept': 'application/json'
                },
                params: params
            })
                .then(response => {

                    const meta = response.data.meta;

                    this.current = parseInt(meta.pagination.current_page);
                    this.totalPages = parseInt(meta.pagination.total);

                    this.limit = parseInt(meta.pagination.per_page);
                    this.total = parseInt(meta.pagination.total);

                    this.aggregations = meta.aggregation;

                    UrlHelpers.setParam('page', this.current);
                    UrlHelpers.setParam('sort', this.sort);

                    this.shouldRefresh = false;

                    this.resolving = false;


                    resolve(response.data);
                })
                .catch(error => {
                    this.errors = error.response.data;
                    this.resolving = false;
                    reject(error);
                });
        });
    },

    getAutocomplete(term, cancel) {
        return axios({
            method: 'get',
            url: '/api/search/autocomplete',
            headers: {
                'Accept': 'application/json'
            },
            cancelToken: cancel.token,
            params: {
                term: term,
            }
        });
    },

    skuMatch(sku, cancel) {
        return axios({
            method: 'get',
            url: '/api/search/sku',
            headers: {
                'Accept': 'application/json'
            },
            cancelToken: cancel.token,
            params: {
                sku: sku,
            }
        });
    },

    /**
     * Get suggestions based on search
     * @param {string} keywords
     * @param {string} type
     */
    getSuggestions(keywords, type, per_page = 8) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url: '/api/search',
                headers: {
                    'Accept': 'application/json'
                },
                params: {
                    type: type,
                    keywords: keywords,
                    per_page: per_page
                }
            }).then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
        });
    },

    /**
     * Set the current page
     * @param {number} page
     */
    setPage(page) {
        this.current = page;
        return this;
    },

    /**
     * Set the total records count
     * @param {Number} total
     */
    setTotal(total) {
        this.total = total;
    },

    /**
     * Set the current category
     * @param {string} category
     */
    setCategory(category, slug) {
        this.category = category;
        this.categorySlug = slug;
    },

    /**
     * Set the total pages
     * @param {number} total
     */
    setTotalPages(total) {
        this.totalPages = total;
    },

    /**
     * Set the query
     * @param {string} query
     */
    setQuery(query) {
        this.query = query;
    },


    /**
     * Set the sort
     * @param {string} value
     */
    setSort(value) {
        this.sort = value;
    },

    /**
     * Add a filter to the search
     * @param {string} field
     * @param {mixed} value
     */
    addFilter(field, value) {
        this.filters = Object.assign({}, this.filters, {
            [field] : value
        });
        return this;
    },

    /**
     * Parse the aggregation
     * @param {Object} aggregations
     */
    aggregate(aggregations) {
        this.aggregations = aggregations;
    },

    bump() {
        this.trigger += this.trigger;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Search.js